import { render, staticRenderFns } from "./BrandCart.vue?vue&type=template&id=5349f4fa&scoped=true&"
import script from "./BrandCart.vue?vue&type=script&lang=js&"
export * from "./BrandCart.vue?vue&type=script&lang=js&"
import style0 from "./BrandCart.vue?vue&type=style&index=0&id=5349f4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349f4fa",
  null
  
)

export default component.exports